/**
 * Vietnamese đồng.
 */
export var VND = {
  code: 'VND',
  base: 10,
  exponent: 0
};